import { putApi } from "./api_instance";

export const updateUserProfile = async (userData, dispatch) => {
  try {
    return await putApi({
      apiUrl: "/api/user/profile",
      dispatch,
      sendToken: true,
      data: userData,
    });
  } catch (error) {
    throw error;
  }
};
